const configurationManager = require('../config/configurationManager') as typeof import('../config/configurationManager');
const stringUtil = require('../string/stringUtil') as typeof import('../string/stringUtil');
const logger = require('../logger/logger') as typeof import('../logger/logger');

export function isImgixUrl(resourceName: unknown): boolean
{
    return typeof resourceName === 'string' && resourceName.includes('imgix.net');
}

/**
 * Logs when an asset is treated as Cloudinary (i.e. it is not an Imgix URL).
 */
export function logCloudinaryUrlDetected(
    resourceName: string,
    messageContext: Record<string, unknown> = {}
): void
{
    if (stringUtil.isStringNullOrEmpty(resourceName))
        return;

    logger.info(`Cloudinary URL detected: ${resourceName}`, {
        publicId: resourceName,
        ...messageContext,
    });
}

export function getUrl(resourceName: string): string
{
    if (stringUtil.isStringNullOrEmpty(resourceName))
        return '';

    if (isImgixUrl(resourceName))
        return resourceName;

    logCloudinaryUrlDetected(resourceName, { source: 'cloudinaryUtils.getUrl' });

    const cloudName = configurationManager.getConfig().cdnUsersCloudName;
    return `https://res.cloudinary.com/${cloudName}/image/upload/${resourceName}`;
}

const cloudinaryUtils = {
    isImgixUrl,
    logCloudinaryUrlDetected,
    getUrl,
};

export default cloudinaryUtils;
